import { render, staticRenderFns } from "./manureRight3.vue?vue&type=template&id=4f5ea364&scoped=true&"
import script from "./manureRight3.vue?vue&type=script&lang=js&"
export * from "./manureRight3.vue?vue&type=script&lang=js&"
import style0 from "./manureRight3.vue?vue&type=style&index=0&id=4f5ea364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ea364",
  null
  
)

export default component.exports